module.exports = __webpack_public_path__ + "img/tick.4f906c0a.svg";